import React from "react";
import "./LinkButtons.css";

const LinkButtons = ({ btnName, dataLinks }) => {
	const handleClick = () => {
		if (!dataLinks || dataLinks.length === 0) return;

		const link = dataLinks[0].link;

		if (link === "soon") {
			alert("Coming Soon!");
			return;
		}

		window.open(link, "_blank", "noopener,noreferrer");
	};

	return (
		<button
			className="link-container xsm:py-0 xsm:text-xxsm px-1 py-2 text-base sm:text-lg"
			onClick={handleClick}
		>
			{btnName}
		</button>
	);
};

export default LinkButtons;
